import Loading from './Loading.vue';

Loading.install = (Vue) => {
  Vue.component(Loading.name, Loading);
};

export default Loading;
